import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ScanSvg = function ScanSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.347 2H4.452v10.225h1.42V3.399h7.886l4.32 4.254v4.572H19.5V7.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.14 8.062h4.738V6.663H8.14zM15.847 12.097h-5.684v-1.4h5.684zM3.5 15.232h17v-1.399h-17v-.857H2v3.259h1.5zM20.5 16.235v-3.259H22v3.259zM6 16.736H4.5v1.504H6zM19.5 18.24v-1.504H18v1.504zM6 20.496v-1.253H4.5V22h3.188v-1.504zM19.5 22v-2.757H18v1.253h-1.687V22zM14.438 20.496H9.561V22h4.876z"
  }));
};
export var Scan = function Scan(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ScanSvg
  }));
};